
import Vue from 'vue'
import { addressesDoNotMatch, formatAddress } from './AddressUtilities'
import { AddressFinder } from '@/components'
import { Textbox, DropDownSelect } from '@/components/formGroups'
import AddressConfirmModal from './AddressConfirmModal.vue'

import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { CountryOption } from '@ViewModels/CountryOption'
import { CheckoutStreetAddressDto } from '@ViewModels/CheckoutStreetAddressDto'

export default Vue.extend({
   name: 'AddressEditorForm',
   props: {
      id: { type: String, required: true },
      type: { type: String, default: 'Shipping' },
      default: {
         type: Object as () => CheckoutStreetAddressDto,
         default: () => ({ ContactPhoneNumber: '' }),
      },
   },
   data() {
      return {
         searchText: '',
         address: {
            AddressLine1: '',
            AddressLine2: '',
            AddressLine3: '',
            City: '',
            Region: '',
            Country: '',
            Postcode: '',
            OtherInformation: '',
            ContactPhoneNumber: '',
            Type: 'Residential',
         } as CheckoutStreetAddressDto,
         confirmModalVisible: false,
         addressSearchError: false,
         editing: false,
         highlight: false,
      }
   },
   computed: {
      countryCode(): string {
         if (this.address.Country) {
            const countries: CountryOption[] = this.modelData.CountryOptions
            const country = countries.find(co => co.Name === this.address.Country)
            if (country) {
               return country.Code
            }
         }
         return this.$store.state.modelData.CountryCode
      },
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      countryOptions(): NameValuePair[] {
         const countries: CountryOption[] = this.modelData.CountryOptions
         return countries.map(c => ({
            name: c.Name,
            value: c.Name,
         }))
      },
      lockCountry(): boolean {
         return this.$store.state.modelData.LockCountryToParty
      },
      addressTypeOptions(): NameValuePair[] {
         return [
            { name: 'Residential Address', value: 'Residential' },
            { name: 'School Address', value: 'School' },
         ]
      },
      addressSummary(): string {
         return formatAddress(this.address)
      },
      showErrors(): boolean {
         return this.$store.state.showErrors
      },
   },
   mounted() {
      const modelData: CheckoutPageModel = this.$store.state.modelData
      if (!!modelData.PartyCountryId) {
         this.setInitialCountryId(modelData.PartyCountryId)
      } else {
         this.setInitialCountryId(modelData.MarketCountryId)
      }
      if (this.default && this.default.ContactPhoneNumber) {
         this.address.ContactPhoneNumber = this.default.ContactPhoneNumber
      }
   },
   methods: {
      manuallyEdit() {
         this.editing = true
      },
      setInitialCountryId(countryId: string) {
         const countries: CountryOption[] = this.modelData.CountryOptions
         const country = countries.find(co => co.Id === countryId)
         if (country) {
            this.address.Country = country.Name
         }
      },
      confirmAddress() {
         this.editing = false
         this.confirmModalVisible = false
      },
      rejectAddress() {
         this.editing = true
         this.confirmModalVisible = false
         this.address.AddressLine1 = this.searchText
      },
      addressSelected(address: CheckoutStreetAddressDto) {
         address.ContactPhoneNumber = this.address.ContactPhoneNumber
         Vue.$assign(this.address, address)
         this.updateAddress()
         this.highlight = true
         this.warnIfLookedUpAddressDoesNotMatch()
      },
      addressFinderError(errorMessage: string) {
         this.addressSearchError = true
         this.editing = true
      },
      searchTextChanged(text: string) {
         this.searchText = text
      },
      updateAddress() {
         this.$store.commit('setAddress', { type: this.type, address: this.address })
      },
      updateCountry() {
         if (this.type !== 'Shipping') {
            return
         }
         const countries: CountryOption[] = this.modelData.CountryOptions
         const country = countries.find(co => co.Name === this.address.Country)
         if (country) {
            this.$store.dispatch('setShippingCountryId', country.Id)
         }
      },
      warnIfLookedUpAddressDoesNotMatch() {
         const mismatch = addressesDoNotMatch(this.searchText, this.address)
         if (mismatch) {
            this.confirmModalVisible = true
         }
      },
   },
   components: {
      Textbox,
      DropDownSelect,
      AddressFinder,
      AddressConfirmModal,
   },
})
